import styled from "styled-components";
import RichText from "../rich-text";

const List = styled.ul`
  margin-top: 0;
  margin-bottom: 1rem;
  padding-left: 2rem;
`;

const getList = (type) => {
  return ({ content }) => (
    <List as={type}>
      <RichText content={content} />
    </List>
  );
};

export default getList;
